import utils from "./utils";

export default function () {
  function changeTitlePlaces() {
    let img = document.querySelectorAll(".text-image__text .title");
    for (let i = 0; i < img.length; i++) {
      const element = img[i];
      const parent = element.closest(".text-image");
	  parent.prepend(element);
    }
  }
  

  if(utils.isMobile()) {
	  changeTitlePlaces();
  }
}
